import { base64ToByteArray } from './base64TtoByteArray'



export function formatUpdateA3DocJson({
    token,
    documentData
}) {
    const getFK = (customerId, code) => `${customerId}-${code.padStart(5, '0')}`;
    const attr800 = documentData.attributes.find(attr => attr.id === "800");
    const code800 = attr800 ? attr800.value.padStart(5, '0') : "";

    const attr801 = documentData.attributes.find(attr => attr.id === "801");
    const value801 = attr801 ? attr801.value.padStart(5, '0') : "";

    const attr802 = documentData.attributes.find(attr => attr.id === "802");
    const desc802 = attr802 ? attr802.description.padStart(5, '0') : "";

    const documentAttributeValues = [
        {
            "ID": "1",
            "DetailsMainField": "Identificador",
            "Items": [
                {
                    "Name": "Identificador",
                    "Value": documentData.customerId
                },
                {
                    "Name": "Nombre",
                    "Value": documentData.customerName
                }
            ]
        },
        ...documentData.attributes.map(attr => {
            if (attr.id === "800") {
                return {
                    "ID": "800",
                    "DetailsMainField": "Código",
                    "Items": [
                        { "Name": "Código", "Value": attr.value.padStart(5, '0') },
                        { "Name": "Nombre", "Value": attr.description || "" },
                        { "Name": "Empresa", "Value": documentData.customerName },
                        { "Name": "Cliente", "Value": documentData.customerName },
                        { "Name": "FK", "Value": documentData.customerId }
                    ]
                };
            } else if (attr.id === "801") {
                return {
                    "ID": "801",
                    "DetailsMainField": "Código",
                    "Items": [
                        { "Name": "Código", "Value": attr.value.padStart(5, '0') },
                        { "Name": "Nombre", "Value": attr.description || "" },
                        { "Name": "Empresa", "Value": documentData.customerName },
                        { "Name": "Cliente", "Value": documentData.customerName },
                        { "Name": "FK", "Value": documentData.customerId }
                    ]
                };
            } else if (attr.id === "802") {
                return {
                    "ID": "802",
                    "DetailsMainField": "Trabajador",
                    "Items": [
                        { "Name": "NIF", "Value": attr.value },
                        { "Name": "Nombre", "Value": desc802 || "" },
                        { "Name": "Centro", "Value": value801 }, // Reemplaza con el valor adecuado
                        { "Name": "Empresa", "Value": documentData.customerName },
                        { "Name": "FK", "Value": getFK(documentData.customerId, code800) }
                    ]
                };
            }
            return null;
        }).filter(Boolean)
    ];

    let plantillaModificada = {
        "Token": token || null,
        "documentId": documentData.id,
        "Content": base64ToByteArray(documentData.docData) || [],
        "Extension": documentData.type || "",
        "ContainersIds": documentData.containersId || [],
        "isAppDocument": documentData.isAppDoc === 'true' ? true : false,
        ...(documentData.isAppDoc && { "ApplicationGUIDs": ['21DC83DB-B187-4993-8C3E-0B4DF8B15632'] }),
        "DocumentAttributes": [
            {
                "Name": "Cliente",
                "Value": documentData.customerId,
                "ID": "1",
                "Description": documentData.customerName
            },
            {
                "Name": "Título",
                "Value": documentData.title,
                "ID": "3",
                "Description": ""
            },
            ...documentData.attributes
                .filter(attr => attr.id !== "1" && attr.id !== "3")
                .map(attr => ({
                    "Name": attr.name,
                    "Value": attr.value,
                    "ID": attr.id,
                    "Description": attr.description || ""
                }))
        ],
        "DocumentAttributeValues": documentAttributeValues
    };

    return plantillaModificada;
}
